import axios, { Axios, AxiosInstance } from "axios";
import { getIpAddress } from "../utils/utils";
import { initCommonLib } from "common-lib";
import { toast } from "react-toastify";

declare global {
  interface Window {
    __ENV__: {
      API_URL: string;
      PORT: string;
    };
  }
}
// const apiBaseUrl = `${window.location.protocol}//${window.location.hostname}`;
// console.log("process.env.NODE_ENV", process.env.NODE_ENV);

export const BASE_URL = process.env.NODE_ENV === "development" ? process.env.REACT_APP_API_URL : getIpAddress();

// console.log("BASE_URL", BASE_URL);

export const client: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

initCommonLib(client);

export const SSE_URL = "/sse";

// 토큰 확인
client.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// access token 갱신
const refreshAccessToken = async () => {
  const access_token = localStorage.getItem("access_token");
  const refresh_token = localStorage.getItem("refresh_token");
  // console.log(typeof refresh_token);
  try {
    const response = await axios.post(
      `${BASE_URL}/refresh`,
      { refresh_token },
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      },
    );
    const { access_token: newAccessToken } = response.data;
    localStorage.setItem("access_token", newAccessToken);
    return newAccessToken;
  } catch (error: any) {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("userInfo");

    toast.error("세션이 만료되었습니다. 다시 로그인해주세요.");

    setTimeout(() => {
      window.location.href = "/login";
    }, 1500);

    throw error;
  }
};

const AUTH_URLS = ["/signin", "/refresh", "/hisso-login", "/hisso-link"];

export const AI_SERVER_DISCONNECTED_EVENT = "ai-server-disconnected";

// 401 에러 처리
client.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    // console.log("error", error);
    if (error.response?.status === 503 && error.response?.data?.code === "AI_SERVER_DISCONNECTED") {
      window.dispatchEvent(new CustomEvent(AI_SERVER_DISCONNECTED_EVENT));
    }
    // 로그인 실패(잘못된 id/pw) 같은 인증 요청의 401은 세션 만료가 아니므로 refresh 하지 않음
    const isAuthRequest = AUTH_URLS.some((url) => originalRequest?.url?.startsWith(url));
    if (error.response?.status === 401 && !isAuthRequest && !originalRequest._retry) {
      originalRequest._retry = true;
      const newAccessToken = await refreshAccessToken();
      // console.log(newAccessToken);
      axios.defaults.headers.common["Authorization"] = `Bearer ${newAccessToken}`;
      originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
      return client(originalRequest);
    }
    return Promise.reject(error);
  },
);

export function getErrorMessage(error: any) {
  if (error.response?.status === undefined) {
    return "서버와 통신할 수 없습니다.";
  }
  return error.response?.data.message || error.message;
}
